import React, { useState } from "react";
import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import OurApi from "../homeslide/OurApi";
import Detailservice from "./detailservice";
const useStyle = makeStyles((theme) => ({
  cardstyle: {
    height: "auto",
    width: "25%",
    margin: "2rem",
    minHeight: 360,
    borderRadius: 8,
    boxShadow: "1px 1px 10px 0px rgba(191,192,191,1)",
    WebkitBoxShadow: "1px 1px 10px 0px rgba(191,192,191,1)",
    MozBoxShadow: "1px 1px 10px 0px rgba(191,192,191,1)",
  },
  root: {
    height: "100%",
    width: "100%",
    backgroundColor: "#FFFFFF",
  },
  secondtext: {
    fontSize: "1.2rem",
    fontWeight: 200,
    textAlign: "center",
    color: "#595A5A",
    maxWidth: 860,
  },
  mainitem: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    paddingTop: "2rem",
  },
}));

const Servicetype = () => {
  const classes = useStyle();
  const [value, setValue] = useState(0);

  return (
    <Grid container spacing={0} className={classes.root}>
      <Grid
        item
        xs={12}
        style={{
          height: "100%",
        }}
      >
        <div className={classes.mainitem}>
          {/* <Typography className={classes.secondtext}>
            Usu habeo equidem sanctus no. Suas summo id sed, erat erant oporteat
            cu pri. In eum omnes molestie. Sed ad debet scaevola, ne mel.
          </Typography> */}
        </div>
        <OurApi type={value} setType={setValue}>
          <Detailservice type={value} setType={setValue} />
        </OurApi>
      </Grid>
    </Grid>
  );
};

export default Servicetype;
